import lunr from "lunr";
import * as SearchConstant from "../../components/Constants/SearchConstant";
import * as ErrorUtils from "../Utils/ErrorUtils";
import * as GenericFetch from "../Request/GenericFetch";

import LogService from "./LogService";

const LOG_TAG = "SERVICE:SEARCH";

export const searchTextInLunrIndex = (index, value) => {
    LogService.trace(LOG_TAG, "searchTextInLunrIndex", "enter");
    let searchText = value.trim().replace(/ +/g, "* ") + "*";// search word beginning with...
    let searchResult = [];
    try {
        searchResult = index.search(searchText);
    } catch (error) {
        LogService.error(LOG_TAG, "searchTextInLunrIndex error", error);
    }
    return searchResult;
}

export const loadSearchIndexFiles = () => {
    LogService.trace(LOG_TAG, "loadSearchIndexFiles");

    const promiseArray = [];
    Object.entries(SearchConstant.SearchIndexPaths).forEach(([key, value]) => {
        promiseArray.push(
            GenericFetch.fetchFile(SearchConstant.DOC_PATH + value)
                .then(data => {
                    LogService.debug(LOG_TAG, "[loadSearchIndexFiles]", value, "loaded");
                    return Promise.resolve({ [key]: lunr.Index.load(data) });
                })
                .catch(errorPayload => {
                    LogService.warn(LOG_TAG, "[loadSearchIndexFiles] file", value, " not found.");
                    return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(value + " not found"));
                })
        )
    });
    return Promise.allSettled(promiseArray)
        .then(results => {
            LogService.trace(LOG_TAG, "[loadSearchIndexFiles] promise all success");
            let indexFileListObject = {};
            results.forEach((item) => {
                if (item.status === "fulfilled") {
                    indexFileListObject = {
                        ...indexFileListObject,
                        ...item.value
                    }
                }
            });
            return Promise.resolve(indexFileListObject);
        });
}